class BaseFormSchema {
	static debug = false
	private _form: HTMLFormElement
	private validations: object
	private rules: object
	private fieldsConfigurations: object
	private fieldsValueOnEmpty: object
	private dependFields: object
	fields: BaseFieldSchema[]
	attributes: BaseAttributeSchema[]

	constructor(options: { fields, attributes: BaseAttributeSchema | BaseAttributeSchema[] }) {
		this.validations = {}
		this.fieldsConfigurations = {}
		this.fieldsValueOnEmpty = {}
		this.dependFields = {}
		this.rules = {}
		this.validateOptions(options)
		this._form = <HTMLFormElement><any>$(this.element())

		for (let field of this.fields) {
			let type = field.type
			let name = field.name

			let config: any = {}
			if (this.fieldsConfigurations[name] !== undefined) {
				config = this.fieldsConfigurations[name]
			}

			if (type == 'choice-radio') {
				let selector = `[name='${name}']`
				let element = this._form.find(selector)
				element.parent().checkbox(config)
			}

			if (type == 'select') {
				if (config.message == undefined) {
					config.message = {
						addResult: 'Agregar <b>{term}</b>',
						count: '{count} seleccionados',
						maxSelections: 'La cantidad máxima de selecciones es {maxCount}',
						noResults: 'No hay resultados.'
					}
				}
				let selector = `[name='${name}']`
				let element = this._form.find(selector)
				element.dropdown(config)
			}
		}
	}

	get form(): HTMLFormElement {
		return this._form
	}

	initValidations() {

		let _fields = {}

		let form = this._form

		for (let field of this.fields) {

			if (field.type == 'submit') continue;

			let validations = this.validations[field.name]

			if (validations === undefined) continue

			let rules = <any[]>validations.rules
			let prompts = <any[]>validations.prompts

			let _field: {
				identifier: string,
				rules: any[],
			} = {
				identifier: '',
				rules: []
			}

			_field.identifier = field.name

			for (let i = 0; i < rules.length; i++) {

				let rule = rules[i]
				let prompt = prompts[i]

				let _rule: {
					type: string,
					prompt?: string
				} = {
					type: '',
				}

				if (typeof rule == 'function') {

					let ruleName = '__function_rule_' + Date.now().toString()

					$.fn.form.settings.rules[ruleName] = (value) => {
						let fieldElement = form.find(`[name='${field.name}']`)
						return rule(value, fieldElement)
					}

					if (prompt != null) {
						_rule.prompt = prompt
					}

					_rule.type = ruleName

				} else {

					_rule.type = rule

					if (prompt != null) {
						_rule.prompt = prompt
					}
				}


				_field.rules.push(_rule)
			}
			this.rules[field.name] = _field
			_fields[field.name] = _field
		}

		let formConfig = {
			inline: true,
			onFailure: function (formErrors, fields) {

				let firstError = form.find('.field.error:first')

				$([document.documentElement, document.body]).animate({
					scrollTop: firstError.offset().top
				}, 500)

			},
			fields: _fields
		}

		form.form(formConfig)

		let dependFields = this.dependFields
		let rules = this.rules
		form.change(function (e) {
			for (let fieldName in dependFields) {
				let _dependsField = dependFields[fieldName]
				if (_dependsField.length > 0) {
					let _rules: { rules: any[] }
					if (rules[fieldName] != undefined) {
						/* for (let r of rules[fieldName].rules) {
							_rules.push(r.type)
						} */
						_rules = {
							rules: rules[fieldName].rules
						}
					} else {
						continue
					}

					let validate = true

					let _field = <JQuery>form.find(`[name='${fieldName}']`)

					for (let depend of _dependsField) {
						let dependFieldSelector = `[name='${depend.field}']`
						let _dField = form.find(dependFieldSelector)

						if (_dField.attr('type') == 'radio') {
							_dField = form.find(`${dependFieldSelector}:checked`)
						}

						let controlValue = depend.value
						let value = _dField.val()
						let isFunction = typeof controlValue == 'function'

						if (value == undefined) {
							validate = false
							break
						}
						if (!isFunction) {

							if (Array.isArray(value)) {

								if (value.indexOf(controlValue) == -1) {
									validate = false
									break
								}

							} else {

								if (value != controlValue) {
									validate = false
									break
								}

							}

						} else {

							validate = controlValue(value)

							if (typeof validate != 'boolean') {
								console.error('La función de validación en dependFields no ha devuelto un valor booleano')
								return
							}

							if(!validate){
								break
							}

						}
					}


					try {
						form.form('remove fields', [fieldName])
					} catch (e) {
						console.warn(e)
					}

					if (validate) {

						form.form('add rule', fieldName, _rules)

						_field.removeAttr('schema-ignore-value')

						let container = _field.parent()

						if (!container.hasClass('field')) {
							container = container.parent()
						}

						if (container.hasClass('disabled')) {
							container.removeClass('disabled')
						}

					} else {

						_field.attr('schema-ignore-value', '')

						let container = _field.parent()
						if (!container.hasClass('field')) {
							container = container.parent()
						}
						if (!container.hasClass('disabled')) {
							container.addClass('disabled')
						}
						if (container.hasClass('error')) {
							container.removeClass('error')
						}
						container.find('.ui.prompt').remove()

						if (_field.attr('type') == 'radio') {

							_field.parent().checkbox('uncheck')

						} else if (_field.parent().hasClass('dropdown')) {

							_field.dropdown('clear')
							_field.dropdown('refresh')

						} else {
							_field.val('')
						}
					}

				}
			}
		})

		form.change()
	}

	getValues() {
		let values = this._form.form('get values')

		for (let name in values) {

			let selector = `[name='${name}']`
			let field = <JQuery>this._form.find(selector)

			if (field.attr('type') == 'checkbox' || field.attr('type') == 'radio') {
				selector = `${selector}:checked`
				field = this._form.find(selector)
			}

			let value: any = ''

			if (field.length > 0) {
				value = field.val()
			}

			if (typeof value == 'string') {
				let _value = value.trim()
				if (_value.length == 0) {
					value = this.fieldsValueOnEmpty[name]
				}
			}

			let ignore = field.attr('schema-ignore-value') != undefined

			if (ignore) {
				value = this.fieldsValueOnEmpty[name]
			}

			values[name] = value

		}

		return values
	}

	setValidation(field: BaseFieldSchema, options: { validation: string | FunctionStringCallback, prompt?: string }) {
		if (typeof options.validation != 'function' && typeof options.validation != 'string') {
			throw new TypeError('El parámetro validation debe ser tipo function|string')
		}
		if (options.prompt === undefined) options.prompt = null
		if (options.prompt !== null && typeof options.prompt != 'string') {
			throw new TypeError('El parámetro prompt debe ser tipo string')
		}

		if (this.validations[field.name] === undefined) {
			this.validations[field.name] = {
				rules: [],
				prompts: []
			}
		}

		this.validations[field.name].rules.push(options.validation)
		this.validations[field.name].prompts.push(options.prompt)
		/* console.log(field.name)
		console.log(this.validations[field.name])
		console.log(options)
		console.log('--------------------') */
	}

	isValid(): boolean {
		return this._form.form('is valid')
	}

	private element(): HTMLFormElement {
		let form = document.createElement('form')
		let attrs = this.attributes
		let fields = Array.isArray(this.fields) ? this.fields : [this.fields]

		for (let attr of attrs) {
			form.setAttribute(attr.name, attr.value)
		}

		for (let field of fields) {
			let excludeLabels = ['']
			let excludeWrapper = ['']
			let selfWrapper = ['choice-radio']
			let fieldElement = field.element
			let wrapper = fieldElement
			let groupedWrapper = document.createElement('div')

			if (excludeWrapper.indexOf(field.type) == -1) {

				wrapper = document.createElement('div')

				let wrapperClasses = ['field']
				let groupedWrapperClasses = ['grouped', 'fields']

				let hasLabel = field.label.length > 0 && field.type != 'submit'

				if (hasLabel && excludeLabels.indexOf(field.type) == -1) {
					let label = document.createElement('label')
					label.innerHTML = field.label
					wrapper.appendChild(label)
					if (field.type == 'choice-radio') {
						groupedWrapper.appendChild(label)
					} else {
						wrapper.appendChild(label)
					}
				}

				if (selfWrapper.indexOf(field.type) != -1) {
					let fieldInnerHTML = fieldElement.innerHTML
					fieldElement.innerHTML = wrapper.innerHTML + fieldInnerHTML
					wrapper = fieldElement
				} else {
					wrapper.appendChild(fieldElement)
					if (fieldElement.hasAttribute('required')) {
						wrapperClasses.push('required')
					}
					wrapper.setAttribute('class', wrapperClasses.join(' '))
				}

				if (fieldElement.hasAttribute('required')) {
					groupedWrapperClasses.push('required')
				}

				if (field.type == 'choice-radio') {
					groupedWrapper.setAttribute('class', groupedWrapperClasses.join(' '))
					groupedWrapper.appendChild(wrapper)
					wrapper = groupedWrapper
				}
			}

			form.appendChild(wrapper)
		}

		let hasClass = form.getAttribute('class') !== null
		let classes = []
		if (hasClass) {
			classes = form.getAttribute('class').trim().split(' ')
		}
		let hasUi = false
		let hasForm = false
		for (let _class of classes) {
			if (_class == 'ui') {
				hasUi = true
			}
			if (_class == 'form') {
				hasUi = true
			}
		}
		if (!hasUi) {
			classes.push('ui')
		}
		if (!hasForm) {
			classes.push('form')
		}
		form.setAttribute('class', classes.join(' '))



		return form
	}

	/**
	 * @method validateOptions
	 * @description Valida las opciones
	 * @param options Opciones a validar
	 * @returns {object} Las opciones con valores por defecto en caso de necesitarlos
	 */
	private validateOptions(options) {
		if (options === undefined || typeof options != 'object') {
			throw new TypeError(`Se esperaba que options fuera tipo object`)
		}
		this.validateAttributes(options.attributes)
		this.validateFields(options.fields)

	}
	private validateAttributes(attributes) {

		let _attributes = []

		attributes = attributes == undefined ? null : attributes

		if (attributes !== null && !BaseAttributeSchema.attrsValidate(attributes)) {
			throw new TypeError(`Se esperaba que attributes fuera tipo BaseAttributeSchema o BaseAttributeSchema[]`)
		}

		if (attributes !== null) {
			attributes = Array.isArray(attributes) ? attributes : [attributes]
			for (let attr of attributes) {
				_attributes.push(new BaseAttributeSchema(attr))
			}
		}
		this.attributes = _attributes
	}

	private validateFields(fields) {

		if (!BaseFieldSchema.fieldsValidate(fields)) {
			throw new TypeError(`Se esperaba que fields fuera un objeto BaseFieldSchema o BaseFieldSchema[]`)
		}

		let fieldsParam = <Array<FieldParam>>(Array.isArray(fields) ? fields : [fields])
		let _fields = []

		for (let field of fieldsParam) {

			if (field.attributes === undefined) {
				field.attributes = []
			}

			let canBeMultiple = ['select',]

			if (canBeMultiple.indexOf(field.type) != -1) {
				field.multiple = field.multiple === true ? true : false
				if (field.multiple) {
					field.attributes.push(new BaseAttributeSchema({ name: 'multiple' }))
				}
			}

			let _field = new BaseFieldSchema(<any>field)

			let choicesFields = ['choice-radio', 'select',]

			if (choicesFields.indexOf(field.type) != -1) {

				if (field.choices != undefined) {

					_field.setChoices(field.choices)

				} else {

					throw new TypeError(`Los campos tipo ${choicesFields.join('|')} deben tener la opción choices`)

				}

			}

			if (field.rules !== undefined) {

				field.rules = Array.isArray(field.rules) ? field.rules : [field.rules]

				for (let rule of field.rules) {
					let _rule: {
						validation: string | FunctionStringCallback,
						prompt?: string
					} = {
						validation: '',
						prompt: undefined
					}

					if (typeof rule == 'string' || typeof rule == 'function') {

						_rule.validation = rule

					} else if (typeof rule == 'object') {

						_rule.validation = rule.type

						if (rule.prompt !== undefined) {
							_rule.prompt = rule.prompt
						}

					}

					if (_rule.validation === undefined) {
						continue
					}

					this.setValidation(_field, _rule)
				}

			}

			if (field.valueOnEmpty !== undefined) {
				if (typeof field.valueOnEmpty == 'function') {
					field.valueOnEmpty = field.valueOnEmpty()
				} else if (
					typeof field.valueOnEmpty == 'symbol' ||
					typeof field.valueOnEmpty == 'object'
				) {
					field.valueOnEmpty = JSON.stringify(field.valueOnEmpty)
				}
			} else {
				field.valueOnEmpty = ''
			}
			this.fieldsValueOnEmpty[field.name] = field.valueOnEmpty

			if (field.dependFields !== undefined) {
				if (!Array.isArray(field.dependFields)) {
					throw new TypeError(`La opcion dependFields debe ser un array`)
				}
				for (let i = 0; i < field.dependFields.length; i++) {
					let _dField = field.dependFields[i]
					if (typeof _dField.field != 'string') {
						throw new TypeError(`La opcion dependFields.field debe ser tipo string`)
					}
					if (typeof _dField.value != 'string' && typeof _dField.value != 'function') {
						throw new TypeError(`La opcion dependFields.value debe ser tipo string o una función que retorne un bool.`)
					}
				}
			} else {
				field.dependFields = []
			}

			this.dependFields[field.name] = field.dependFields

			let ignoreProperties = [
				'name',
				'required',
				'label',
				'type',
				'rules',
				'attributes',
				'choices',
				'valueOnEmpty',
				'multiple',
				'dependFields',
			]

			let properties = Object.getOwnPropertyNames(field)

			for (let index in properties) {
				let property = properties[index]
				if (ignoreProperties.indexOf(property) == -1) {
					if (this.fieldsConfigurations[field.name] == undefined) {
						this.fieldsConfigurations[field.name] = {}
					}
					this.fieldsConfigurations[field.name][property] = field[property]
				}
			}

			_fields.push(_field)
		}
		this.fields = _fields

	}
	static isForm(form): form is BaseFormSchema {
		if (
			(form.fields !== undefined) &&
			(
				form.attributes == undefined ||
				BaseAttributeSchema.isAttribute(form.attributes) ||
				BaseAttributeSchema.isAttributeArray(form.attributes)
			)
		) {
			return true
		}
		return false
	}

}

interface FieldParam {
	name: string
	required?: boolean
	label?: string
	type?: string
	rules?: any
	attributes?: Array<{ name: string, value?: string }>
	choices?: Array<{ value: string, display?: string }>
	valueOnEmpty?: any
	multiple?: boolean
	dependFields?: Array<{ field: string, value: any }>
}